interface CandidateNameIconProps {
  color?: string;
  className?: string;
}

const CandidateNameIcon = ({ color = "#9CA3AF", className }: CandidateNameIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M8 10C9.38071 10 10.5 8.88071 10.5 7.5C10.5 6.11929 9.38071 5 8 5C6.61929 5 5.5 6.11929 5.5 7.5C5.5 8.88071 6.61929 10 8 10Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 3H2.5C2.22386 3 2 3.22386 2 3.5V12.5C2 12.7761 2.22386 13 2.5 13H13.5C13.7761 13 14 12.7761 14 12.5V3.5C14 3.22386 13.7761 3 13.5 3Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75635 13C4.06608 12.1218 4.64058 11.3614 5.40066 10.8236C6.16074 10.2857 7.06895 9.99683 8.0001 9.99683C8.93124 9.99683 9.83946 10.2857 10.5995 10.8236C11.3596 11.3614 11.9341 12.1218 12.2438 13"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CandidateNameIcon;
